// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:960px){.storyblok-action-button button{width:100%!important}}", ""]);
// Exports
module.exports = exports;
